import { render, staticRenderFns } from "./VersionTab.vue?vue&type=template&id=61ad6e74&"
import script from "./VersionTab.vue?vue&type=script&lang=js&"
export * from "./VersionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports